import {useMutation, useQueryClient} from "@tanstack/react-query";
import {toast} from "react-toastify";
import {MAIN_REJESTR_API_SHORT} from "../../../../components/utils/consts.js";
import {create} from "../../../app/setters/create.js";

import {useSelector} from "react-redux";
export const useKlonujProjekt = () => {
    const queryClient = useQueryClient();
    const role = useSelector(state => state.user.role) // to string
    const roleParam = role === 'oper' ? 'oper' : '';

    console.log({roleParam, role});

    return useMutation({
        mutationFn: (id) => create(`/${MAIN_REJESTR_API_SHORT}/${roleParam}klonuj`, {id: id}),
        onSettled: async () => {
            await queryClient.invalidateQueries({
                predicate: query => query.queryKey[0].startsWith(`lista_projektow__/rejestr/lista`),
            });
        },
        onSuccess: ({message, status}) => {
            return status !== 'success' ? toast.error(message) : toast.success(message)
        },
    });
};
